import { isLegacyClarityRoute } from 'src/utils/clarityView';

export const shouldRenderSideNavOrgSelector = (
  revampExperience: boolean,
  isLargeScreen: boolean,
): boolean => !revampExperience || !isLargeScreen;

export const shouldShowLegacyNavigation = (
  explicitlyOpen: boolean,
  hasActiveLegacyRoute: boolean,
): boolean => explicitlyOpen || hasActiveLegacyRoute;

export type RevampNavigationPlacement = 'primary' | 'legacy' | 'hidden';

export const getRevampNavigationPlacement = ({
  hiddenFromRevampNavigation,
  isLegacy,
  revampSection,
}: {
  hiddenFromRevampNavigation?: boolean;
  isLegacy?: boolean;
  revampSection?: string;
}): RevampNavigationPlacement => {
  if (hiddenFromRevampNavigation) return 'hidden';
  if (isLegacy) return 'legacy';

  return revampSection ? 'primary' : 'hidden';
};

export const getSideNavPath = (route: string): string => {
  const [path] = route.split('?');

  return path.startsWith('/') ? path : `/${path}`;
};

export const getSideNavAnalyticsTarget = (route: string): string => {
  const target = route.startsWith('/') ? route.slice(1) : route;

  return target || 'home';
};

export const shouldShowSourceHealthNavigation = (
  revampExperience: boolean,
  sourceHealthEnabled: boolean,
): boolean => !revampExperience || sourceHealthEnabled;

const DEFAULT_MEMORY_TAB = 'generalMemoryList';

export const isSideNavRouteActive = ({
  route,
  pathname,
  search,
  careOperationsEnabled,
  revampExperience,
}: {
  route: string;
  pathname: string;
  search: string;
  careOperationsEnabled: boolean;
  revampExperience?: boolean;
}): boolean => {
  const [path, query = ''] = route.split('?');

  // Board and backlog are children of the sprint workspace, so keep its
  // navigation item selected while planning or reviewing a sprint.
  if (path === 'sprints' && pathname.startsWith('/sprints/')) return true;

  if (`/${path}` !== pathname) return false;

  const requestedSearch = new URLSearchParams(query);
  const currentSearch = new URLSearchParams(search);

  if (path === 'whats-happening' && revampExperience) {
    return (
      isLegacyClarityRoute(requestedSearch) ===
      isLegacyClarityRoute(currentSearch)
    );
  }

  if (path === 'memory' && requestedSearch.has('tab')) {
    return (
      requestedSearch.get('tab') ===
      (currentSearch.get('tab') ?? DEFAULT_MEMORY_TAB)
    );
  }

  if (path !== 'tasks' || !careOperationsEnabled) return true;

  return requestedSearch.get('surface') === 'actions'
    ? currentSearch.get('surface') === 'actions'
    : currentSearch.get('surface') !== 'actions';
};
